export default __webpack_public_path__ + "static/media/shape.a3d9a204.png";